import { SDEventTypesCountedAs } from "../../../types/staticData.types"

export enum SchedulesFilter {
	NORMAL = "normal",
	UNALLOCATED = "Un Allocated",
	DELETED = "deleted",
}

export enum ScheduleStatus {
	ACCEPTED = "ACCEPTED",
	REJECTED = "REJECTED",
	PENDING = "PENDING",
	INACTIVE = "INACTIVE",
}

export type ScheduleStatusAndType = ScheduleStatus | SDEventTypesCountedAs

export const ScheduleStatusToColor = {
	[ScheduleStatus.ACCEPTED]: "#53917A",
	[ScheduleStatus.REJECTED]: "#B83720",
	[ScheduleStatus.PENDING]: "#F27410",
	[ScheduleStatus.INACTIVE]: "#EACF60",
	[SDEventTypesCountedAs.WORK]: "#6E9107",
	[SDEventTypesCountedAs.HOLIDAY]: "#F24141",
	[SDEventTypesCountedAs.TRAINING]: "#3D70DD",
	[SDEventTypesCountedAs.SICKNESS]: "#EACF60",
	[SDEventTypesCountedAs.NONE]: "#EACF60", // TODO verify changes
}
